import { makeStyles } from '@mui/styles';
import Divider from 'apollo-react/components/Divider';
import Modal from 'apollo-react/components/Modal';
import React, { useEffect, useMemo, useState } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import MainSection from './Components/MainSection';
import { SearchSection } from './Components/SearchSection';
import {
  clearHelpTopicsError,
  setCurrentQuestion,
  setNewQuestionAndAnswers,
  setOpenHelpTopicsModal,
} from '../../actions/HelpTopicsActions';
import CustomLoader from '../../components/CustomLoader';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import { getIsOpen, getQuestionsAndAnswers } from '../../selectors/HelpTopicsSelectors';
import { getJsonFreeStorageItem } from '../../utils/storageUtils';

const useStyles = makeStyles({
  content: {
    height: 500,
  },
  modal: {
    minWidth: '55%',
    '@media(max-width: 1300px)': {
      minWidth: '70%',
    },
    '@media(max-width: 1000px)': {
      minWidth: '90%',
    },
  },
  divider: {
    margin: '20px 0',
  },
  mainSectionContainer: {
    height: 420,
  },
});

const HelpTopicsDialogComponent = () => {
  const { isMobileDevice } = useWindowDimensions();
  const dispatch = useDispatch();
  const classes = useStyles();
  const translateString = useTranslation();
  const [questionValue, setQuestionValue] = useState('');
  const [isLoading, setLoading] = useState(false);

  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const isOpen = useSelector(getIsOpen);

  useEffect(() => {
    const jsonFree = getJsonFreeStorageItem('questionsAndAnswers') || [];
    if (jsonFree.length !== questionsAndAnswers.length) {
      dispatch(setNewQuestionAndAnswers(jsonFree));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleModalClose = () => {
    setQuestionValue('');
    batch(() => {
      dispatch(setOpenHelpTopicsModal(false));
      dispatch(setCurrentQuestion(null));
      dispatch(clearHelpTopicsError);
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const latestAskedQuestion = useMemo(() => questionsAndAnswers.slice(0, 10), [
    questionsAndAnswers.length,
  ]);

  const props = {
    questionValue,
    isLoading,
    latestAskedQuestion,
    setQuestionValue,
    setLoading,
  };

  return (
    <Modal
      hideButtons
      className={classes.modal}
      disableBackdropClick
      disableEscapeKeyDown
      disablePortal
      onClose={() => handleModalClose()}
      open={isOpen}
      title={translateString('Help Topics')}
      PaperProps={{ style: { margin: isMobileDevice ? 16 : 32 } }}
    >
      <div className={classes.content}>
        <SearchSection {...props} />
        <Divider className={classes.divider} />
        <div className={classes.mainSectionContainer}>
          {isLoading ? <CustomLoader /> : <MainSection {...props} />}
        </div>
      </div>
    </Modal>
  );
};

export default HelpTopicsDialogComponent;
